import PaymentCardBody from './_components/payments-card-body'

function Payments() {
  return (
    <div className="w-full">
      <div className="flex flex-row justify-between w-full">
        <h1 className="text-2xl md:text-[32px] font-bold mb-2">Payments</h1>
      </div>
      <PaymentCardBody />
    </div>
  )
}

export default Payments
